module.exports = __webpack_public_path__ + "fonts/ToyotaType-BookIt.76eaf09.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/ToyotaType-BookIt.woff2
// module id = gapE
// module chunks = 13